import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Order } from '../../../models/orderModel';

@Component({
    selector: 'app-payment-failure',
    templateUrl: './payment-failure.component.html',
    styleUrls: ['./payment-failure.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentFailureComponent implements OnInit {
  @Input() order: Order;

  constructor() {}

  ngOnInit(): void {}
}
